import _ from "underscore";
import apiClient from "@/common/gateway-api";
import * as Actions from "@/store/actions.type";
import * as Mutations from "@/store/mutations.type";

export default {
  state: {
    loading: true,
    errors: null,
    success: null,
    component: null
  },
  mutations: {
    [Mutations.SET_COMPONENT_LOADING](state, loading) {
      state.loading = loading;
    },
    [Mutations.SET_COMPONENT_ERROR](state, error) {
      state.errors = error;
    },
    [Mutations.SET_COMPONENT_SUCCESS](state, success) {
      state.success = success;
    },
    [Mutations.SET_COMPONENT](state, component) {
      state.component = component;
    },
    [Mutations.REMOVE_COMPONENT](state, id) {
      state.component = state.component.filter((item) => item.id != id);
    }
  },
  actions: {
    [Actions.FETCH_ALL_COMPONENT]({ commit }, { region, hardRefresh }) {
      const day = 60 * 60 * 24 * 1000;
      if (
        !localStorage.getItem(`abi_${region}_components`) ||
        Date.now() -
          JSON.parse(localStorage.getItem(`abi_${region}_components`))
            .timestamp >
          day ||
        hardRefresh
      ) {
        apiClient
          .get(`/api/v1/woo/components`, { params: { region } })
          .then((response) => {
            commit(Mutations.SET_COMPONENT_LOADING, false);
            commit(Mutations.SET_COMPONENT, response.data.data);

            localStorage.setItem(
              `abi_${region}_components`,
              JSON.stringify({
                data: response.data.data,
                timestamp: Date.now()
              })
            );
          })
          .then(() => {
            commit(
              Mutations.SET_COMPONENT_SUCCESS,
              `${region.toUpperCase()} Components Fetched Success!`
            );
            setTimeout(() => {
              commit(Mutations.SET_COMPONENT_SUCCESS, null);
            }, 5000);
          })
          .catch((error) => {
            commit(Mutations.SET_COMPONENT_LOADING, false);
            commit(Mutations.SET_COMPONENT_ERROR, error);
          });
      } else {
        commit(Mutations.SET_COMPONENT_LOADING, false);
        commit(
          Mutations.SET_COMPONENT,
          JSON.parse(localStorage.getItem(`abi_${region}_components`)).data
        );
      }
    },
    [Actions.DELETE_COMPONENT]({ commit }, { region, id }) {
      apiClient
        .delete(`/api/v1/woo/components/${id}`, { params: { region } })
        .then(() => {
          commit(Mutations.REMOVE_COMPONENT, id);
        })
        .catch((error) => {
          commit(Mutations.SET_COMPONENT_ERROR, error);
        });
    },
    [Actions.CLEAR_HARDREFRESH_ERRORS]({ commit }) {
      commit(Mutations.SET_COMPONENT_ERROR, null);
    },
    [Actions.CLEAR_HARDREFRESH_SUCCESS]({ commit }) {
      commit(Mutations.SET_COMPONENT_SUCCESS, null);
    }
  },
  getters: {
    componentLoading(state) {
      return state.loading;
    },
    hardRefreshErrors(state) {
      return state.errors;
    },
    hardRefreshSuccess(state) {
      return state.success;
    },
    getAllComponent(state) {
      return _.sortBy(state.component, (c) => parseInt(c.id));
    }
  }
};
